import styled from '@emotion/styled'
import { useAdministrationStateContext } from '../components/state'

const Content = styled.div`
    overflow-y: scroll;
    height: 80%;
    margin: 0.5rem;
`

const ErrorDiv = styled.div`
    margin: 0.5rem;
    padding: 0.5rem;
    white-space: pre-wrap;
`

export function ErrorDisplay() {
    const { globalState: state } = useAdministrationStateContext()

    return <Content>
        {state.errors.map((error, key) =>
            <div key={key}>
                <ErrorDiv>
                    {error.message}
                </ErrorDiv>
                <ErrorDiv>
                    {error.stacktrace}
                </ErrorDiv>
            </div>
        )}
    </Content>
}